export default [
  {
    name: 'app_key',
    label: 'App Key',
    type: 'text',
    required: true,
    helpText: 'Enter the app key for this service. BigPanda creates this key when you\'re configuring the service.',
    errorText: 'Please enter app key.',
  },
  {
    name: 'token',
    label: 'Token',
    type: 'text',
    required: true,
    helpText: 'Enter the token for your BigPanda Account.',
    errorText: 'Please enter token',
  },
];
